// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"210":"15370bc9","242":"c6aabc0d"}[chunkId] + ".chunk.css";
};